<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-row :gutter="24">
        <a-col :span="4" v-if="isTree">
          <!-- 部门树 -->
          <dept-tree ref="deptTree" :deptOptions="deptOptions" @select="clickDeptNode" />
        </a-col>
        <a-col :span="isTree ? 20 : 24">
          <!-- 条件搜索 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="48">
                <a-col :md="8" :sm="24">
                  <a-form-item label="用户名称">
                    <a-input v-model="queryParam.nickName" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="手机号">
                    <a-input v-model="queryParam.phoneNumber" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
                <template v-if="advanced">
                  <a-col :md="8" :sm="24">
                    <a-form-item label="状态" prop="status">
                      <a-select v-model="queryParam.status" placeholder="请选择状态" style="width: 100%" allow-clear>
                        <a-select-option
                          v-for="(d, index) in dict.type['sys_normal_disable']"
                          :key="index"
                          :value="d.value"
                          >{{ d.label }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="8" :sm="24" v-if="isTree">
                    <a-form-item label="单位" prop="tenantId">
                      <a-select
                        show-search
                        v-model="queryParam.tenantId"
                        placeholder="请选择单位"
                        style="width: 100%"
                        allow-clear
                        option-filter-prop="children"
                        :filter-option="filterOption"
                      >
                        <a-select-option v-for="(d, index) in tenantListed" :key="index" :value="d.tenantId">{{
                          d.tenantName
                        }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="8" :sm="24" v-if="isTree">
                    <a-form-item label="区域" prop="regionId">
                      <a-select
                        show-search
                        v-model="queryParam.regionId"
                        placeholder="请选择区域"
                        style="width: 100%"
                        allow-clear
                        option-filter-prop="children"
                        :filter-option="filterOption"
                      >
                        <a-select-option v-for="(d, index) in userRegion" :key="index" :value="d.id">{{
                          d.name
                        }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="8" :sm="24" v-if="isTree">
                    <a-form-item :label="userType == 2 ? '分销商' : '经销商'" prop="tenantAgentId">
                      <a-select
                        v-model="queryParam.tenantAgentId"
                        :placeholder="userType == 2 ? '请选择分销商' : '请选择经销商'"
                        style="width: 100%"
                        allow-clear
                        show-search
                        option-filter-prop="children"
                        :filter-option="filterOption"
                      >
                        <a-select-option v-for="(d, index) in agentList" :key="index" :value="d.id">{{
                          d.name
                        }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="8" :sm="24">
                    <a-form-item label="时间范围">
                      <a-range-picker
                        style="width: 100%"
                        v-model="dateRange"
                        valueFormat="YYYY-MM-DD"
                        format="YYYY-MM-DD"
                        allow-clear
                      />
                    </a-form-item>
                  </a-col>
                </template>
                <a-col :md="(!advanced && 8) || 24" :sm="24">
                  <span
                    class="table-page-search-submitButtons"
                    :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
                  >
                    <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                    <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                    <a @click="toggleAdvanced" style="margin-left: 8px">
                      {{ advanced ? '收起' : '展开' }}
                      <a-icon :type="advanced ? 'up' : 'down'" />
                    </a>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <!-- 操作 -->
          <div class="table-operations">
            <template v-if="isTree">
              <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['system:user:add']">
                <a-icon type="plus" />新增
              </a-button>
              <a-button
                type="primary"
                @click="$refs.uploadAdd.init(role == 'YSY00' ? 4 : 5)"
                v-hasPermi="['system:user:import']"
                v-if="role"
              >
                <a-icon type="plus" />批量新增
              </a-button>
              <a-button
                type="primary"
                :disabled="single"
                @click="$refs.createForm.handleUpdate(undefined, ids)"
                v-hasPermi="['system:user:edit']"
              >
                <a-icon type="edit" />修改
              </a-button>
              <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['system:user:remove']">
                <a-icon type="delete" />删除
              </a-button>
              <a-button
                type="primary"
                @click="$refs.CreateTable.handleAdd(role)"
                v-hasPermi="['4efa00bbd3cb874031337ae373434d80:0:1']"
              >
                查看所有{{ role == 'YSY00' ? '验收员' : role == 'SG00' ? '水工' : '用户' }}
              </a-button>
              <!-- <a-button
                type="dashed"
                @click="$refs.importExcel.importExcelHandleOpen()"
                v-hasPermi="['system:user:import']"
              >
                <a-icon type="import" />导入
              </a-button> -->
              <!-- <a-button type="primary" @click="handleExport" v-hasPermi="['system:user:export']">
                <a-icon type="download" />导出
              </a-button> -->
            </template>
            <table-setting
              :style="{ float: 'right' }"
              :table-size.sync="tableSize"
              v-model="columns"
              :refresh-loading="loading"
              @refresh="getList"
            />
          </div>
          <!-- 增加修改 -->
          <!-- 创建/编辑用户,单独封装了组件 -->
          <create-form
            ref="createForm"
            :deptOptions="deptOptions"
            :statusOptions="dict.type['sys_normal_disable']"
            :sexOptions="dict.type['sys_user_sex']"
            @ok="getList"
            :role="role"
            @select-tree="getTreeselect"
            :userRegion="userRegion"
          />
          <CreateAcountPhone ref="CreateAcountPhone" @ok="getList"></CreateAcountPhone>
          <uploadAdd ref="uploadAdd" @ok="getList"></uploadAdd>

          <CreateTable ref="CreateTable" :role="role"></CreateTable>
          <!-- 个人的资金账户 -->
          <CreateAcount ref="CreateAcount" @ok="getList"></CreateAcount>
          <!-- 修改密码抽屉 -->
          <reset-password ref="resetPassword" />
          <!-- 分配角色模态框 -->
          <auth-role ref="authRole" />
          <!-- 上传文件 -->
          <import-excel ref="importExcel" @ok="getList" />
          <a-button type="primary" v-if="isTreeUser" @click="handleSubChoose"> 确认选择 </a-button>
          <!-- 数据展示 -->
          <a-table
            :loading="loading"
            :size="tableSize"
            rowKey="id"
            :columns="columns"
            :data-source="list"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="false"
            :bordered="tableBordered"
          >
            <!-- tips: 此处的status 其实是后端的enable字段，所以status '0' 代表的是开启  status '1' 代表的是关闭 -->
            <span slot="status" slot-scope="text, record">
              <template v-if="isTree">
                <a-popconfirm
                  ok-text="是"
                  cancel-text="否"
                  @confirm="confirmHandleStatus(record)"
                  @cancel="cancelHandleStatus(record)"
                >
                  <span
slot="title"
                    >确认<b>{{ record.status === 0 ? '启用' : '停用' }}</b
                    >{{ record.nickName }}的用户吗?</span
                  >
                  <a-switch
                    checked-children="开"
                    un-checked-children="关"
                    :checked="record.status === 1"
                  /> </a-popconfirm
              ></template>
              <template v-else>
                <a-tag color="red" v-if="record.status == 0"> 禁用 </a-tag>
                <a-tag color="green" v-else> 启用 </a-tag>
              </template>
            </span>
            <span slot="createTime" slot-scope="text, record">
              {{ parseTime(record.createTime) }}
            </span>
            <span slot="operation" slot-scope="text, record" v-if="record.id !== 1">
              <a @click="$refs.CreateAcountPhone.handleUpdate(record, undefined)" v-hasPermi="['system:user:edit']" v-if="infoUser.account=='admin'"> 修改 </a>
              <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['system:user:edit']" v-else> 修改 </a>
              <a-divider
                type="vertical"
                v-hasPermi="['system:user:resetPwd', 'system:user:edit', 'system:user:resetPwd']"
              />
              <a-dropdown v-hasPermi="['system:user:resetPwd', 'system:user:edit', 'system:user:remove']">
                <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                  <a-icon type="double-right" />
                  更多
                </a>
                <a-menu slot="overlay">
                  <a-menu-item v-hasPermi="['system:user:resetPwd']">
                    <a @click="handleDelete(record)" v-hasPermi="['system:user:remove']"> 删除 </a>
                  </a-menu-item>
                  <a-menu-item v-hasPermi="['system:user:resetPwd']">
                    <a @click="$refs.resetPassword.handleResetPwd(record)"> 重置密码 </a>
                  </a-menu-item>
                  <a-menu-item v-hasPermi="['system:user:edit']">
                    <a @click="$refs.authRole.handleAuthRole(record)"> 分配角色 </a>
                  </a-menu-item>
                  <a-menu-item v-hasPermi="['sys:fund:connect:list']">
                    <a @click="$refs.CreateAcount.handleUpdate(record, undefined)"> 资金账户 </a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
          </a-table>
          <!-- 分页 -->
          <a-pagination
            class="ant-table-pagination"
            show-size-changer
            show-quick-jumper
            :current="queryParam.pageNum"
            :total="total"
            :page-size="queryParam.pageSize"
            :showTotal="(total) => `共 ${total} 条`"
            @showSizeChange="onShowSizeChange"
            @change="changeSize"
          />
        </a-col>
      </a-row>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUser, delUser, changeUserStatus, deptTreeSelect } from '@/api/system/user'
import AuthRole from './modules/AuthRole'
import CreateAcountPhone from './modules/CreateAcountPhone'
import { pageMy } from '@/api/pressure/dispatch'
import ResetPassword from './modules/ResetPassword'
import CreateAcount from './modules/CreateAcount'
import CreateTable from './modules/CreateTable'
import CreateForm from './modules/CreateForm'
import { regionList } from '@/api/pressure/region'
import ImportExcel from './modules/ImportExcel'
import DeptTree from './modules/DeptTree'
import { tableMixin } from '@/store/table-mixin'
import { mapGetters } from 'vuex'
import uploadAdd from '../tenant/modules/uploadAdd.vue'
export default {
  name: 'User',
  components: {
    AuthRole,
    ResetPassword,
    CreateForm,
    ImportExcel,
    DeptTree,
    CreateAcount,
    CreateTable,
    uploadAdd,
    CreateAcountPhone,
  },
  mixins: [tableMixin],
  dicts: ['sys_normal_disable', 'sys_user_sex'],
  props: {
    type: {
      type: Number,
    },
    isTree: {
      type: Boolean,
      default: true,
    },
    isTreeUser: {
      type: Boolean,
      default: false,
    },
    role: {
      type: String,
    },
    tenantId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      list: [],
      agentList: [],
      selectedRowKeys: [],
      selectedRows: [],
      userRegion: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 部门树选项
      deptOptions: [
        {
          id: 0,
          label: '',
          children: [],
        },
      ],
      // 日期范围
      dateRange: [],
      tenantListed: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        userName: undefined,
        phoneNumber: undefined,
        status: undefined,
        deptId: undefined,
        tenantAgentId: undefined,
        regionId: undefined,
      },
      columns: [
        {
          title: '序号',
          key: 'index',
          width: 80,
          align: 'center',
          customRender: (text, record, index) => {
            // 从1开始编号
            return index + 1
            // 如果分页，可以加上页码偏移量：
            // return (this.pagination.current - 1) * this.pagination.pageSize + index + 1;
          },
        },
        // {
        //   title: '用户名',
        //   dataIndex: 'userName',
        //   align: 'center',
        // },
        {
          title: '用户名称',
          dataIndex: 'nickName',
          align: 'center',
        },
        {
          title: '手机号',
          dataIndex: 'phoneNumber',
          align: 'center',
        },
        {
          title: '积分',
          dataIndex: 'integralCount',
          align: 'center',
        },
        {
          title: '部门',
          dataIndex: 'dept.deptName',
          scopedSlots: { customRender: 'dept.deptName' },
          align: 'center',
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    this.queryParam.type = this.type
    // console.log(this.);

    if (!this.isTree) {
      this.columns.pop()
      this.queryParam.tenantId = this.tenantId
      console.log(this.tenantId, 'this.tenantId')
      console.log(this.columns, 'columnscolumns')
    }
    if (this.userType == 0) {
      this.tenantListed = this.infoUser.tenantListed
    } else {
      const arr = JSON.parse(JSON.stringify(this.infoUser.tenantListed))
      arr.unshift({ tenantId: 0, tenantName: '全部' })
      this.tenantListed = arr
    }
    console.log(this.tenantListed, 'tenantListed')

    this.getList()
    if (this.isTree) {
      this.getDeptTree()
    }
    if (this.userType === 1 || this.userType === 0) {
      if (this.isTree) {
        this.getMy(2)
        this.getQu()
      }
    }
    if (this.userType == 2) {
      this.getMy(3)
    }
  },
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    getTreeselect() {},
    // 查询经销商
    getMy(type) {
      pageMy({ type: type }).then((res) => {
        console.log(res, 'resres=====0--，。。。')
        this.agentList = res.data.records
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 查询区域
    getQu() {
      regionList().then((res) => {
        console.log(res, '的点点滴滴')
        this.userRegion = res.data
      })
    },
    /** 查询用户列表 */
    getList() {
      this.loading = true
      pageUser(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 查询部门下拉树结构 */
    getDeptTree() {
      deptTreeSelect().then((response) => {
        this.deptOptions = response.data
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      if (this.dateRange.length) {
        this.queryParam.createBeginTime = this.dateRange[0] + ' ' + '00:00:00'
        this.queryParam.createEndTime = this.dateRange[1] + ' ' + '23:59:59'
      } else {
        this.queryParam.createBeginTime = ''
        this.queryParam.createEndTime = ''
      }
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        userName: undefined,
        phoneNumber: undefined,
        status: undefined,
        deptId: undefined,
        tenantAgentId: undefined,
        regionId: undefined,
      }
      this.queryParam.tenantId = this.tenantId
      this.queryParam.type = this.type

      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    clickDeptNode(deptId) {
      this.queryParam.deptId = deptId
      this.handleQuery()
    },
    /* 用户状态修改 status 0开启 1关闭*/
    confirmHandleStatus(row) {
      const oldStatus = row.status
      const text = row.status === 0 ? '启用' : '关闭'
      const status = row.status === 1 ? 0 : 1
      changeUserStatus(row.id, status)
        .then((res) => {
          if (res.success) {
            row.status = status
            this.$message.success(text + '成功', 3)
          } else {
            row.status = oldStatus
            this.$message.error(`${text}失败, ${res.message}`, 3)
          }
        })
        .catch(() => {
          this.$message.error(text + '异常', 3)
        })
    },
    cancelHandleStatus(row) {},
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const userIds = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + userIds + '的数据',
        onOk() {
          return delUser(userIds).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    // 选择用户
    handleSubChoose() {
      this.$emit('backCange', this.selectedRowKeys)
      console.log(this.selectedRowKeys, 'selectedRowKeysselectedRowKeysselectedRowKeys')
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/user/export',
            {
              ...that.queryParam,
            },
            `user_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
